// eslint-disable-next-line import/no-unresolved
import keenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

class RecentlyViewed extends HTMLElement {
  constructor () {
    super()

    const recommendedSection = document.querySelector(
      '.sec-Section-recommended'
    )

    const recentlyViewed = document.querySelector(
      '.sec-FeaturedProducts-recentlyViewed'
    )
    const recentlyViewedTabTrigger = document.querySelector(
      '.tab-Tabs_Button-recentlyViewed'
    )
    const tabTriggers = document.querySelectorAll('.tab-Tabs_Button')

    const carousel = recentlyViewed.querySelector('#recently_viewed_ul')

    const controlPrevEl = recentlyViewed.querySelector(
      '[data-el="featured-products.controlprevious"]'
    )
    const controlNextEl = recentlyViewed.querySelector(
      '[data-el="featured-products.controlnext"]'
    )

    const scrollerEl = recentlyViewed.querySelector(
      '[data-el="featured-products.scroller"]'
    )

    Shopify.Products.showRecentlyViewed({
      maxToShow: 8,
      minToShow: 1,
      onComplete () {
        const carouselItems = carousel.querySelectorAll('.car-Carousel_Slide')

        recentlyViewedTabTrigger.style.display = 'block'
        recentlyViewed.classList.remove(
          'sec-FeaturedProducts-hiddenRecentlyViewed'
        )
        recentlyViewed.classList.add(
          `sec-FeaturedProducts-${carouselItems.length}`
        )

        // eslint-disable-next-line new-cap
        const slider = new keenSlider(carousel, {
          slides: '.car-Carousel_Slide',
          slidesPerView: 1.33333,
          spacing: 5,
          rubberband: false,
          breakpoints: {
            '(min-width: 600px)': {
              slidesPerView: 2,
              spacing: 5,
            },
            '(min-width: 768px)': {
              slidesPerView: 2.4,
              spacing: 10,
            },
            '(min-width: 901px)': {
              slidesPerView: 3,
              spacing: 10,
            },
            '(min-width: 1201px)': {
              slidesPerView: 4,
              spacing: 10,
            },
          },
          created: () => {
            const slidesToShow = 1.33333
            const slidesToShow600 = 2
            const slidesToShow768 = 2.4
            const slidesToShow901 = 3
            const slidesToShow1201 = 4

            const totalSlidesToShow = carouselItems.length

            const scrollerWidth = (slidesToShow * 100.0) / totalSlidesToShow
            const scrollerWidth600 =
              (slidesToShow600 * 100.0) / totalSlidesToShow
            const scrollerWidth768 =
              (slidesToShow768 * 100.0) / totalSlidesToShow
            const scrollerWidth901 =
              (slidesToShow901 * 100.0) / totalSlidesToShow
            const scrollerWidth1201 =
              (slidesToShow1201 * 100.0) / totalSlidesToShow

            scrollerEl.style.cssText = `--width: ${scrollerWidth}%; --width_600: ${scrollerWidth600}%; --width_768: ${scrollerWidth768}%; --width_901: ${scrollerWidth901}%; --width_1201: ${scrollerWidth1201}%;`

            carousel.classList.remove('car-Carousel_Slides-hidden')
          },
          slideChanged: instance => {
            const maxClicks =
              instance.details().size - instance.details().slidesPerView

            instance.details().relativeSlide === 0
              ? (controlPrevEl.disabled = true)
              : (controlPrevEl.disabled = false)
            instance.details().relativeSlide >= maxClicks
              ? (controlNextEl.disabled = true)
              : (controlNextEl.disabled = false)
          },
          move: instance => {
            if (scrollerEl) {
              let progressTrack = instance.details().progressTrack
              progressTrack = progressTrack >= 1 ? 0 : progressTrack
              const movementPercentage = progressTrack * 100
              scrollerEl.style.setProperty(
                '--movement',
                `${movementPercentage}%`
              )
            }
          },
        })

        controlPrevEl.addEventListener('click', onNavClick.bind(this))
        controlNextEl.addEventListener('click', onNavClick.bind(this))

        function onNavClick (event) {
          if (event.currentTarget.dataset.direction === 'previous') {
            slider.prev()
          } else {
            slider.next()
          }
        }
      },
      onEmpty () {
        if (tabTriggers.length === 1) {
          recommendedSection.hidden = true
        }
      },
    })
    Shopify.Products.recordRecentlyViewed()
  }
}

customElements.define('recently-viewed', RecentlyViewed)
